import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../hooks';
import { SUBSCRIBED_HOME_PATH } from '../utils/subscribedHome';
import { LoadingScreen } from './ui/LoadingScreen';

export const PublicRoute = ({ children }) => {
  const { loading, isAuthenticated, user } = useAuth();

  if (loading) return <LoadingScreen />;

  if (isAuthenticated) {
    const redirectPath = user?.subscription_id
      ? SUBSCRIBED_HOME_PATH
      : '/unsubscribed-landing';

    return (
      <Navigate
        to={redirectPath}
        state={{
          affiliate: user.affiliate,
          userId: user.id,
          userEmail: user.email,
        }}
        replace
      />
    );
  }
  return children ? children : <Outlet />;
};
